import { ALL_NAMESPACES } from './generated'

export { ALL_NAMESPACES }
export type { Resources } from './generated'

export type Namespace = (typeof ALL_NAMESPACES)[number]

export const CORE_NAMESPACES = [
  'common',
  'components',
  'auth',
] as const satisfies readonly Namespace[]

export type CoreNamespace = (typeof CORE_NAMESPACES)[number]

const coreNamespaceSet: ReadonlySet<string> = new Set<string>(CORE_NAMESPACES)

export const LAZY_NAMESPACES: Namespace[] = ALL_NAMESPACES.filter(
  (namespace) => !coreNamespaceSet.has(namespace),
)

export const SUPPORTED_LANGUAGES = ['pt-BR', 'en-US', 'es'] as const

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const DEFAULT_LANGUAGE: SupportedLanguage = 'pt-BR'

export const DEFAULT_NAMESPACE: CoreNamespace = 'common'

const namespaceSet: ReadonlySet<string> = new Set<string>(ALL_NAMESPACES)

export function isNamespace(value: string): value is Namespace {
  return namespaceSet.has(value)
}
